<h2 mat-dialog-title>Confirm Submit</h2>
<mat-dialog-content
    >Changing the UUID will deactivate the existing controller for all current users. Do you wish to
    continue?</mat-dialog-content
>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="">Cancel</button>
    <button mat-button [mat-dialog-close]="true">OK</button>
</mat-dialog-actions>
